import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';
import { LEFT_COLUMN_NAME, RIGHT_COLUMN_NAME } from '../constants';
import type { CustomGridColDef } from '../services';

export type PaddingColumnsConfig = {
  hasSidePanel?: boolean;
  withoutLeftPadding?: boolean;
  withoutRightPadding?: boolean;
};

const getPaddingColumnDefinition = (name: string, hasSidePanel?: boolean): GridColDef => {
  return {
    headerName: '',
    field: name,
    maxWidth: hasSidePanel ? 24 : 32,
    minWidth: hasSidePanel ? 24 : 32,
    resizable: false,
    sortable: false,
  };
};

export const addPaddingColumns = <T extends GridValidRowModel>(
  columns: (GridColDef<T> | CustomGridColDef<T>)[],
  config?: PaddingColumnsConfig,
): {
  columns: (GridColDef<T> | CustomGridColDef<T>)[];
  leftColumnName: string;
  rightColumnName: string;
} => {
  const { hasSidePanel, withoutLeftPadding, withoutRightPadding } = config || {};

  return {
    leftColumnName: LEFT_COLUMN_NAME,
    rightColumnName: RIGHT_COLUMN_NAME,
    columns: [
      withoutLeftPadding ? null : getPaddingColumnDefinition(LEFT_COLUMN_NAME),
      ...columns,
      withoutRightPadding ? null : getPaddingColumnDefinition(RIGHT_COLUMN_NAME, hasSidePanel),
    ].filter(Boolean) as (GridColDef<T> | CustomGridColDef<T>)[],
  };
};
